import { Logger } from '../ui-toolkit/logging/LoggerService';
import { APIFactory } from '../ui-toolkit/rest/APIFactory';
import { baseUrlService } from '../ui-toolkit/rest/BaseUrlService';

export const generateClosingDisclosureAsync = async (orderId: string): Promise<string | Error> => {
  try {
    const response = await APIFactory(baseUrlService.ApiLocation).post<string>(
      `/timber/api/internal/orders/${orderId}/document-packages/closing-disclosure`,
      {}
    );
    return response.data;
  } catch (error: any) {
    Logger.error('Error in RestDocumentsService.generateClosingDisclosureAsync', {
      error,
      orderId,
    });
    throw new Error('There was an error while communicating with Timber!');
  }
};
